import { useEffect } from 'react';
import { BlindWatermark, WatermarkOptions } from 'watermark-js-plus';

import { useAuth } from '@/auth/hooks/useAuth';

export const WATERMARK_OPTIONS: Partial<WatermarkOptions> = {
  contentType: 'multi-line-text',
  width: 420,
  height: 300,
  rotate: 30,
  fontSize: '16px',
  lineHeight: 22,
  fontColor: '#000',
  zIndex: 10,
};

export const useDocumentWatermark = (
  parent: HTMLElement | null,
  documentId: number,
) => {
  const { user } = useAuth();
  const userId = user?.localAccountId ?? '';
  const clientId = user?.tenantId ?? '';

  useEffect(() => {
    if (!parent) return;

    let isDisposed = false;
    const watermark = new BlindWatermark({
      ...WATERMARK_OPTIONS,
      parent,
      content: [
        `User: ${userId}`,
        `Client: ${clientId}`,
        `Document: ${documentId}`,
        new Date().toISOString(),
      ].join('\n'),
    });

    watermark
      .create()
      .then(() => {
        if (isDisposed) watermark.destroy();
      })
      .catch((error: unknown) => {
        console.error('Watermark creation failed:', error);
      });

    return () => {
      isDisposed = true;
      watermark.destroy();
    };
  }, [parent, userId, clientId, documentId]);
};
